// skeleton/app/src/app/shared/components/incident-consent-dialog/consent-dialog.component.ts

import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateSurvey } from 'src/app/shared/components/page/page.model';
import { environment } from 'src/environments/environment';
import { QuestionViewModel } from '../../models/questionview.model';
import { AgencyModel } from '../../models/agency.model';
import { Constants } from '../../constants';
import { AppConstants } from '../../appconstants';
import { StorageService } from '../../services/token-storage.service';

@Component({
  selector: 'app-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.scss'],
  standalone: false,
})
export class ConsentDialogComponent implements OnInit {
  consentNonSignPopUpHeaderHtmlContent: string;
  allConsentQuestions: QuestionViewModel[] = [];
  consentOtherQuestions: QuestionViewModel[] = [];
  agencyName: string;
  agencyId: number;
  consentTitle: string = '';

  surveyViewModel: CreateSurvey = new CreateSurvey();
  constant: Constants = new Constants();
  appConstants: AppConstants = new AppConstants();

  @Output() responseChanged = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<ConsentDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      surveyViewModel: CreateSurvey;
      consentQuestions: QuestionViewModel[];
      selectedChild: any;
      agencyDetails: AgencyModel;
    },
    private storage: StorageService
  ) {
    this.surveyViewModel = data.surveyViewModel;
    this.allConsentQuestions = data.consentQuestions;
    this.agencyName = data.agencyDetails?.agencyName;
    this.agencyId = data.agencyDetails?.agencyId;
  }

  ngOnInit(): void {
    this.consentOtherQuestions = this.allConsentQuestions.filter((q) => q.inputType !== 'sign');
    this.setConsentTitle();
    this.updateConsentContent();
  }

  setConsentTitle(): void {
    const providerType = this.storage.get('LoggedInProviderType');
    if (providerType === this.appConstants.providerTypes.RESIDENTIAL_PROVIDER) {
      this.consentTitle = this.constant.rsConsentPopupTitle;
    } else {
      this.consentTitle = this.constant.scoConsentPopupTitle;
    }
  }

  updateConsentContent(): void {
    const providerType = this.storage.get('LoggedInProviderType');
    let content: string;

    if (providerType === this.appConstants.providerTypes.RESIDENTIAL_PROVIDER) {
      content = environment.consentNonSignPopUpHeaderHtmlContentForRS;
      content = content.replace(
        '<<Provider Legal Name>> <<MPI Number>>',
        `<strong>${this.agencyName}  ${this.agencyId}</strong>`
      );
    } else {
      content = environment.consentNonSignPopUpHeaderHtmlContent;
      content = content.replace(
        '<<Provider Legal Name>> <<MPI Number>>',
        `${this.agencyName}  ${this.agencyId}`
      );
    }

    this.consentNonSignPopUpHeaderHtmlContent = content;
  }

  close(): void {
    this.dialogRef.close();
  }

  UpdateResponse(event: any): void {
    // reserved
  }

  submitConsent(): void {
    this.dialogRef.close({ isConsentAccepted: true });
  }
}
